/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { translate, translateCaseValue } from "@/src/services/translations/translations";
import React from "react";
import { convertValueDependingOnFieldType, fieldPathValueCanBeDisplayed } from "@/src/services/formatService";
import { scrollToAnchor } from "@/src/theme/commonStyle";
import { FieldType } from "@/src/types/formatServiceTypes/FieldType";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";

type SummaryDetailsItemProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  fieldType?: FieldType;
  labelPostfix?: string | null;
};

const SummaryDetailsItem = ({ caseData, fieldPath, fieldType = null, labelPostfix = null }: SummaryDetailsItemProps) => {
  if (!fieldPathValueCanBeDisplayed(caseData, fieldPath)) {
    return null;
  }

  let convertedValue = fieldType === null ? translateCaseValue(caseData, fieldPath) : convertValueDependingOnFieldType(caseData, fieldPath, fieldType);

  let label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  label = labelPostfix ? label + " " + labelPostfix : label;

  return (
    <>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={fieldPath} sx={scrollToAnchor} />
        {label}
      </Grid>
      <Grid size={12}>
        {convertedValue}
      </Grid>
    </>
  );
};

export default SummaryDetailsItem;
